import React from 'react';
import { Switch, } from 'react-router-dom';

import routes from 'routes';
import RoutesRender from './RoutesRender';

const Routes = () => (
    <Switch>
        <RoutesRender routes={routes} />
    </Switch>
);

export default Routes;
